import { Roles } from '../auth/constants/AuthConstants';

export interface IAllAgentsData {
  id: number;
  referenceId: string;
  phoneNumber: string;
  name: string;
  agencyId: number;
  active: boolean;
  emailAddress: string;
  slashUserId: number;
  reportingManagerId: number;
  metadata: IAgentsCenterMetadata;
  fieldAppUserFlag: boolean;
  roles: string[];
  employeeId: string;
  preferences: IPreferences;
  bucketGroup: string;
  weightInfluenceFactor: number;
  enableNewLonghorn: boolean;
  longhornVersion: string;
  reportingManagerName: string;
}
export interface IAgentsCenterMetadata {
  pinCodes: string[];
  agentCenter: string;
}
export interface IPreferences {
  state: string;
  primaryLanguage: string;
  secondaryLanguage: string;
  tertiaryLanguage: string;
}
export interface IPageData {
  pageNo: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
}
export interface IAllAgentsReducer {
  allAgentsData: IAllAgentsData[];
  page: IPageData;
  isLoading: boolean;
  error: string;
}

export const TABLE_NAME = 'allAgents';
export const FILTERS_TABLE_NAME = 'filters';

export const defaultQueryParam: queryParam = {
  pageSize: '50',
  pageNo: '0'
};

export interface queryParam {
  pageSize?: string;
  pageNo?: string;
  sortBy?: string;
  sortDirection?: string;
  query?: string;
}
export interface filtersParams {
  agencyCode?: string;
  agentRole?: string;
  bucketGroup?: string;
  primaryLanguage?: string;
  agentState?: string;
  status?: string;
}

export interface IAllAgentsFilters {
  value: string;
}
export interface filterQueryParams {
  AGENCY_CODE?: Array<IAllAgentsFilters>;
  AGENT_ROLE?: Array<IAllAgentsFilters>;
  BUCKET_GROUP?: Array<IAllAgentsFilters>;
  PRIMARY_LANGUAGE?: Array<IAllAgentsFilters>;
  AGENT_STATE?: Array<IAllAgentsFilters>;
  STATUS?: Array<IAllAgentsFilters>;
}
export interface GridEvent {
  api: any;
}
export const BULK_UPLOAD_DRAWER_TABS = [
  {
    key: 'createNew',
    value: 'New users'
  },
  {
    key: 'updateExisting',
    value: 'Existing users'
  },
  {
    key: 'uploadNumbers',
    value: 'Phone numbers'
  },
  {
    key: 'uploadNdra',
    value: 'NDRA'
  }
];

export const ROLE_OPTIONS = [
  {
    value: Roles.ROLE_HUMAN_REMINDER_AGENT,
    label: 'Human Reminder Agent'
  },
  {
    value: Roles.ROLE_CALLING_AGENT,
    label: 'Calling Agent'
  },
  {
    value: Roles.ROLE_FIELD_AGENT,
    label: 'Field Agent'
  }
];

export const UPLOAD_OPTIONS = [
  {
    value: 'ADD',
    label: 'Add number'
  },
  {
    value: 'DELETE',
    label: 'Delete number'
  }
];

export enum BULK_UPLOAD_FLOW {
  CREATE = 'create',
  EDIT = 'edit',
  NUMBER = 'user_number_mapping',
  NDRA = 'ndra'
}

export const CREATE_NEW = 'createNew';
export const UPDATE_EXISTING = 'updateExisting';
export const UPLOAD_NUMBERS = 'uploadNumbers';
export const NDRA = 'uploadNdra';

export const uploadAgentsSampleCsvFile =
  'phone_number,email_address,name,active,reporting_manager_email_address,state,employee_id,primary_language,secondary_language,tertiary_language,bucket_group,agent_center\n' +
  '9999999999,test@navi.com,xyz,true,system@navi.com,KARNATAKA,1445,HINDI,KANNADA,ENGLISH,IN_HOUSE_TELE_CYCLE_1,PUNE\n' +
  '9999999991,john@navi.com,abc,,system@navi.com,TAMIL_NADU,,TAMIL,,IN_HOUSE_TELE_CYCLE_1,\n' +
  '9999999992,,def,,system@navi.com,,,,,,,\n';

export const uploadEditAgentsSampleCsvFile =
  'phone_number,email_address,active,reporting_manager_email_address,bucket_group,agent_center\n' +
  '9999999999,test@navi.com,true,test1@email.com,None,BANGALORE\n';

const MAX_FILE_SIZE_IN_MB = 5;
const MAX_FILE_SIZE = 1e6 * MAX_FILE_SIZE_IN_MB;

export const validationOfFile = (file: File | null) => {
  if (file) {
    if (file?.size > MAX_FILE_SIZE) {
      return false;
    } else return true;
  }
  return false;
};
